import Input from "../../../../components/Input/Input";
import React from "react";

const Date = ({id, formik, settings = {}}) => {
    return (
        <Input
            name={id}
            label={settings.title}
            type="date"
            className="form"
            required={settings.required}
            value={formik.values[id]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            description={settings.description}
            error={formik.touched[id] && formik.errors[id]}
        />
    )
};

export default Date;